import { useState, useEffect, useCallback } from 'react';
import { emailService } from '../services/api';
import { getCookie } from '../utils/cookieUtils';

const MESSAGES_PER_PAGE = 10;
const POLLING_INTERVAL = 10000;

export const useMessages = (emailAddress) => {
    const [state, setState] = useState({
        messages: [],
        currentPage: 1,
        totalPages: 0,
        loading: true,
    });

    const fetchMessages = useCallback(async (page) => {
        if (!emailAddress) return;

        try {
            const sessionId = getCookie('sessionId');
            const response = await emailService.getMessages(
                emailAddress,
                sessionId,
                page - 1,
                MESSAGES_PER_PAGE
            );
            
            setState(current => ({
                ...current,
                messages: response.data.content,
                totalPages: response.data.totalPages,
                loading: false,
            }));
        } catch (error) {
            console.error('Error fetching messages:', error);
            setState(current => ({ ...current, loading: false }));
        }
    }, [emailAddress]);

    const handlePageChange = useCallback((newPage) => {
        setState(current => ({ ...current, currentPage: newPage }));
        fetchMessages(newPage);
    }, [fetchMessages]);

    // Initial fetch and polling setup
    useEffect(() => {
        if (!emailAddress) return;

        fetchMessages(state.currentPage);

        const pollMessages = () => fetchMessages(state.currentPage);
        const pollingInterval = setInterval(pollMessages, POLLING_INTERVAL);

        return () => clearInterval(pollingInterval);
    }, [emailAddress, state.currentPage, fetchMessages]);

    return {
        ...state,
        handlePageChange,
    };
}; 